module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 012.b57113f6.jpg";